import { IoIosSchool } from "react-icons/io";

const subscriptionDetailsMap = {
  match: {
    etudiant_25_26: {
      title: "Tu es étudiant·e ?",
      description:
        "Grâce au Club étudiants, bénéficie de 10% de remise en bons d’achat sur tous tes achats !",
      callToActionText: "Rejoindre le Club étudiants",
      onClickType: "url",
      callToAction: "https://www.supermarchesmatch-rec.fr/fr/doc/formulaire_club/12100/club-etudiants" ,
      icon: <IoIosSchool className="w-8 h-8" />
    },
  },


};

export const getSubscriptionsDisplayDetails = (subscriptions, storeKey) => {
  storeKey = storeKey.toLowerCase();

  if (
    !subscriptions ||
    Object.keys(subscriptions).length === 0 ||
    !subscriptionDetailsMap[storeKey]
  ) {
    return [];
  }

  const storeSubscriptions = subscriptionDetailsMap[storeKey];
  let subscriptionsDetails = [];

  Object.keys(subscriptions).forEach((key) => {
    if (subscriptions[key] && storeSubscriptions[key]) {
      subscriptionsDetails.push(storeSubscriptions[key]);
    }
  });
  return subscriptionsDetails;
};
